import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';

/**
 * A dialog popup for adding or editing the text in a comment bubble
 */
@Component({
    selector: 'sci-edit-comment-dialog',
    templateUrl: './edit-comment-dialog.component.html'
})
export class EditCommentBubbleDialogComponent implements OnInit {
    text = '';
    isUpdate = false;

    constructor( private _dialogRef: MatDialogRef<EditCommentBubbleDialogComponent>, @Inject(MAT_DIALOG_DATA) public data ) {}

    ngOnInit() {
        if ( this.data ) {
            this.isUpdate = true;
            this.text = this.data;
        }
    }

    addComment() {
        // remove trailing whitespace
        if ( this.text ) {
            this.text = this.text.trim();
        }
        this._dialogRef.close( this.text );
    }
}
